export function getEffectiveCatalogImages(product) {
  const rawImages =
    product?.effectiveImages ??
    product?.EffectiveImages ??
    product?.images ??
    product?.Images ??
    []

  if (!Array.isArray(rawImages)) return []

  const seenUrls = new Set()
  return [...rawImages]
    .sort((a, b) => {
      const aDefault = (a?.isDefault ?? a?.IsDefault) === true ? 0 : 1
      const bDefault = (b?.isDefault ?? b?.IsDefault) === true ? 0 : 1
      return aDefault - bDefault
    })
    .filter(image => {
      const url = image?.url ?? image?.Url
      if (!url || seenUrls.has(url)) return false
      seenUrls.add(url)
      return true
    })
    .map(image => ({
      ...image,
      id: image?.id ?? image?.Id ?? image?.url ?? image?.Url,
      url: image?.url ?? image?.Url
    }))
}
